import {jsPDF} from 'jspdf';
import {ILabelDesign} from '../models/label-interfaces';

/**
 * True when a label needs a PDF page rotation entry.
 */
export function isWideLabelDesign(design: ILabelDesign): boolean {
  return design.labelWidthMm > design.labelHeightMm;
}

export function getLabelPdfPageFormat(design: ILabelDesign): [number, number] {
  return [design.labelWidthMm, design.labelHeightMm];
}

export function createLabelPdfDocument(design: ILabelDesign): jsPDF {
  const format = getLabelPdfPageFormat(design);
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format,
  });
  if (isWideLabelDesign(design)) {
    pdf.internal.events.subscribe('putPage', function(this: jsPDF): void {
      const internal = this.internal as unknown as {write(value: string): void};
      internal.write('/Rotate 90');
    });
  }
  return pdf;
}

export function addLabelPdfPage(pdf: jsPDF, design: ILabelDesign): void {
  pdf.addPage(getLabelPdfPageFormat(design), 'landscape');
}

export function buildLabelPdfDataUri(pdf: jsPDF): string {
  return pdf.output('datauristring').replace(/filename=[^;]+;/, '');
}
